module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAAQCAMAAADODVF7AAAARVBMVEUAAAD1w6f0w6j2xKj2xKj/uLD2xKj0w6n4xaL1xKf1xKf1w6f3xafzw6f5xKb0w6f1w6f1xqj1w6b1w6b1xKj0xKj1xKcyn/W3AAAAFnRSTlMAs16SjgbyWRD81Mm9QCu3qkz73dWK7sZtLQAAALVJREFUWMPc1DkWwyAMRVFhJjN71P6XGqKDE3CauNVtaGjeLwS/svLGeJWBkQdNWjokTmpg4q8mvaplUauO+BGZLDA2tU64maUgB3YksCCxcwgi5296sjZd/RF7jsUdyA578VqAumu/naqzCLLjQAEDCge7IOWcKjtDmt5KEMTgwAMDHgdGkFAoPIGlN7QBtttnYMDgYGsDBAq3r40GwIjPAiO+EBzx1eBoQ2i0KTzaGRrR3WEAbuIlpbv0aIgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-info-name-1@2x.png
// module id = gAlD
// module chunks = 1